import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';


const RelatedServices = ({ relatedService }) => {
    return (
        <section className="lg:pb-[50px] pb-[50px] bg-white font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full lg:px-[80px] px-[20px]">
                <h2 className="font-[600] font-sora lg:text-[30px] text-[20px] lg:leading-[40px] leading-[30px] text-[#01386A] text-left lg:pb-[80px] pb-[40px]">
                    Related Service Offerings
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:gap-x-[80px] gap-x-0 lg:gap-y-[40px] gap-y-[20px]">
                    {relatedService.map((service, index) => (
                        <div
                            key={service.id}
                            className={`group relative flex items-center cursor-pointer h-[259px] ${index % 2 === 1 ? 'md:mt-[80px]' : ''}`}
                        >
                            <div className="w-full md:max-w-[348px] h-full overflow-hidden relative z-0">
                                <div className="absolute inset-0 bg-blue-900/20 group-hover:bg-transparent transition-all duration-500 z-10"></div>
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full md:max-w-[348px] h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
                                />
                            </div>
                            <div
                                className="absolute right-[5%] w-[90%] md:right-0 md:w-[55%] p-8 shadow-2xl rounded-sm z-20 
               bg-white group-hover:bg-[#01386A] 
               transition-all duration-500 ease-in-out 
               flex flex-col justify-between 
               h-[170px] group-hover:h-[220px]"
                            >
                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                                <div className="absolute bottom-0 left-0 h-[4px] bg-[#FF7F50] w-0 group-hover:w-full transition-all duration-700 ease-in-out z-10"></div>
                                <div className="transition-all duration-500 ease-in-out absolute p-8 left-0 top-0 w-full h-full flex flex-col justify-between
                    opacity-100 translate-y-0
                    group-hover:opacity-0 pointer-events-none">
                                    <h3 className="lg:text-[20px] text-[16px] font-[600] mb-6 leading-[24px] font-sora text-[#01386A]">
                                        {service.title}
                                    </h3>
                                    <span className="inline-flex underline items-center font-[600] font-graphik text-[16px] text-[#01386A]">
                                        <ArrowRight size={16} className="ml-2 text-[#01386A]" />
                                    </span>
                                </div>
                                <div className="transition-all duration-500 ease-in-out absolute p-8 left-0 top-0 w-full h-full flex flex-col justify-center
                    opacity-0 translate-y-4
                    group-hover:opacity-100 group-hover:translate-y-0">
                                    <Link to={service?.link}>
                                        <p className="text-white text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed">
                                            {service.description}
                                        </p>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default RelatedServices;